import { cumulativeSpend } from 'shared/src/domain/line-item/pacing-helpers';
import { LineItemTrpcResponse } from 'shared/src/trpc-types/line-item-trpc-types';

export function generateGraph(lineItem: LineItemTrpcResponse): number[] {
  const { pacing_details } = lineItem;
  if (!pacing_details || pacing_details.length === 0) return [];
  return cumulativeSpend(lineItem.dates, pacing_details).map(day => day.cumulativeTotal);
}
